import React from 'react'
import { HelmetFunc } from 'components/PageMetaData'
import { Layout } from 'layout/Layout'
import { DefaultFormBlock } from 'blocks/DefaultFormBlock'
import { ExamplesOfProjectsViza } from 'blocks/ExamplesOfProjectsViza'

import styled from 'styled-components'
import { backgroundColors, colors } from 'styles/colors'
import { mobileAfterBorder } from 'styles/mobileAfterBorder'
import { displayWidth } from 'styles/width'
import { Container } from 'components/Container'
import { IconListQuestion } from 'components/IconListQuestion'
import { LeftSidebar, RightSidebar } from 'components/SideBar'
import { graphql } from 'gatsby'
import { useTranslation } from 'react-i18next'
import { getDataByLanguage } from 'utils/getDataByLanguage'
import { IItem } from 'types/interfaces'

const pageMetadata = {
    uk: {
        title: 'Зразок 3Д візуалізації інтер`єру квартири від студії',
        description:
            'Приклади рендерів квартири та інтерактивної 3Д візуалізації 360° з реалістичними зображення інтер`єру приміщення',
    },
    ru: {
        title: 'Образец 3Д визуализации интерьера квартиры от студии',
        description:
            'Примеры рендеров квартиры и интерактивной 3Д  визуализации 360° с реалистичными изображения интерьера помещения',
    },
    en: {
        title:
            'A sample of 3D visualization of the interior of the apartment from the studio',
        description:
            'Examples of apartment renderings and interactive 3D visualization 360° with realistic images of the interior of the room',
    },
}

const ProjectStructureWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    position: relative;
    @media (min-width: ${displayWidth.tablet}) {
        border-bottom: 1px solid ${colors.dark};
    }
    ${mobileAfterBorder}
`
const IconListStyled = styled(IconListQuestion)`
    background-color: ${(props) =>
        props.background || backgroundColors.contact};
    border-bottom: 1px solid ${colors.dark};
    h2 {
        font-size: 30px;
        line-height: 35px;
    }
    @media (min-width: ${displayWidth.tablet}) {
        border-bottom: none;
    }
`

const ExampleVizaPage = ({
    data,
}: {
    data: {
        allVisaFaqYaml: { items: IItem }
    }
}) => {
    const { i18n } = useTranslation()
    const vizaData = getDataByLanguage(data.allVisaFaqYaml, i18n.language)

    return (
        <Layout>
            <HelmetFunc data={pageMetadata} />
            <ExamplesOfProjectsViza />
            <ProjectStructureWrapper>
                <LeftSidebar background={backgroundColors.project} />
                <Container columns={'1fr'} tabletColumns={'1fr'}>
                    <IconListStyled
                        items={vizaData.items}
                        fill={colors.accentText}
                        background={backgroundColors.project}
                    />
                </Container>
                <RightSidebar />
            </ProjectStructureWrapper>
            <DefaultFormBlock
                withPhoneMobile
                tracking={{
                    conversionType: 'FormExample',
                    eventCategory: 'FormExample',
                }}
            />
        </Layout>
    )
}

export default ExampleVizaPage

export const query = graphql`
    query {
        allVisaFaqYaml {
            edges {
                node {
                    items {
                        question
                        answer
                    }
                    parent {
                        ... on File {
                            name
                        }
                    }
                }
            }
        }
    }
`
